"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var TableHeader_1 = require("./TableHeader");
// eslint-disable-next-line @typescript-eslint/ban-types
function Table(props) {
    var _a, _b, _c, _d, _e, _f;
    var rowSelectionConfig = props.rowSelection;
    var pagination = (_a = props.pagination) !== null && _a !== void 0 ? _a : { position: ["bottomCenter"], showSizeChanger: false, defaultPageSize: 50 };
    var _g = __read(react_1.useState((_c = (_b = props.rowSelection) === null || _b === void 0 ? void 0 : _b.selectedRowKeys) !== null && _c !== void 0 ? _c : []), 2), selectedRowKeys = _g[0], setSelectedRowKeys = _g[1];
    var _h = __read(react_1.useState(0), 2), numberOfSelectableRows = _h[0], setNumberOfSelectableRows = _h[1];
    // If props.rowSelection.selectedRowKeys is being used, keep the internal selectedRowKeys in sync
    react_1.useEffect(function () {
        var _a, _b, _c;
        // Avoid double render on init
        if (((_a = props.rowSelection) === null || _a === void 0 ? void 0 : _a.selectedRowKeys) !== undefined) {
            setSelectedRowKeys((_c = (_b = props.rowSelection) === null || _b === void 0 ? void 0 : _b.selectedRowKeys) !== null && _c !== void 0 ? _c : []);
        }
    }, [(_d = props.rowSelection) === null || _d === void 0 ? void 0 : _d.selectedRowKeys]);
    var onSelectedRowsChanged = function (selectedRowKeys, selectedRows) {
        var _a;
        if ((_a = props.rowSelection) === null || _a === void 0 ? void 0 : _a.onChange) {
            props.rowSelection.onChange(selectedRowKeys, selectedRows);
        }
        setSelectedRowKeys(selectedRowKeys);
    };
    var rowSelection = __assign(__assign({}, rowSelectionConfig), { selectedRowKeys: selectedRowKeys, onChange: onSelectedRowsChanged });
    react_1.useEffect(function () {
        if (props.dataSource) {
            var count = props.dataSource.reduce(function (count, record) {
                return isRecordDisabled(record) ? count : count + 1;
            }, 0);
            setNumberOfSelectableRows(count);
        }
        else {
            setNumberOfSelectableRows(0);
        }
    }, [props.dataSource]);
    var onTableHeaderSelectAll = function () {
        if (props.dataSource) {
            if (typeof props.rowKey === "string") {
                var selectedRows = props.dataSource.reduce(function (result, record) {
                    var _a, _b;
                    var rowKeyName = props.rowKey;
                    if (((_a = props.rowSelection) === null || _a === void 0 ? void 0 : _a.getCheckboxProps) && !isRecordDisabled(record)) {
                        result.keys.push(record[rowKeyName]);
                        result.rows.push(record);
                    }
                    else if (!((_b = props.rowSelection) === null || _b === void 0 ? void 0 : _b.getCheckboxProps)) {
                        result.keys.push(record[rowKeyName]);
                        result.rows.push(record);
                    }
                    return result;
                }, { keys: [], rows: [] });
                onSelectedRowsChanged(selectedRows.keys, selectedRows.rows);
            }
            else if (typeof props.rowKey === "function") {
                var selectedRows = props.dataSource.reduce(function (result, record, index) {
                    var _a, _b;
                    var rowKeyFunction = props.rowKey;
                    var rowKey = rowKeyFunction(record, index);
                    if (((_a = props.rowSelection) === null || _a === void 0 ? void 0 : _a.getCheckboxProps) && !isRecordDisabled(record)) {
                        result.keys.push(rowKey);
                        result.rows.push(record);
                    }
                    else if (!((_b = props.rowSelection) === null || _b === void 0 ? void 0 : _b.getCheckboxProps)) {
                        result.keys.push(rowKey);
                        result.rows.push(record);
                    }
                    return result;
                }, { keys: [], rows: [] });
                onSelectedRowsChanged(selectedRows.keys, selectedRows.rows);
            }
            else {
                var selectedRows = props.dataSource.reduce(function (result, record) {
                    var _a, _b;
                    if (((_a = props.rowSelection) === null || _a === void 0 ? void 0 : _a.getCheckboxProps) && !isRecordDisabled(record)) {
                        result.keys.push(record["key"]);
                        result.rows.push(record);
                    }
                    else if (!((_b = props.rowSelection) === null || _b === void 0 ? void 0 : _b.getCheckboxProps)) {
                        result.keys.push(record["key"]);
                        result.rows.push(record);
                    }
                    return result;
                }, { keys: [], rows: [] });
                onSelectedRowsChanged(selectedRows.keys, selectedRows.rows);
            }
        }
    };
    var onTableHeaderDeselectAll = function () {
        onSelectedRowsChanged([], []);
    };
    var isRecordDisabled = function (record) {
        var _a, _b;
        if ((_a = props.rowSelection) === null || _a === void 0 ? void 0 : _a.getCheckboxProps) {
            var checkboxProps = props.rowSelection.getCheckboxProps(record);
            return (_b = checkboxProps.disabled) !== null && _b !== void 0 ? _b : false;
        }
        else {
            return false;
        }
    };
    var getRowClassName = function (record, index, indent) {
        var classNames = [];
        switch (typeof props.rowClassName) {
            case "string":
                classNames.push(props.rowClassName);
                break;
            case "function":
                classNames.push(props.rowClassName(record, index, indent));
                break;
        }
        if (isRecordDisabled(record)) {
            classNames.push("disabled-row");
        }
        return classNames.join(" ");
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TableHeader_1.TableHeader, { numberOfRows: (_f = (_e = props.dataSource) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0, numberOfSelectableRows: numberOfSelectableRows, numberOfRowsSelected: selectedRowKeys.length, rowDescriptor: props.rowDescriptor, rowDescriptorPluralized: props.rowDescriptorPluralized, onSelectAll: onTableHeaderSelectAll, onDeselectAll: onTableHeaderDeselectAll, actions: props.actions }),
        react_1.default.createElement(antd_1.Table, __assign({}, props, { rowClassName: function (record, index, indent) { return getRowClassName(record, index, indent); }, rowSelection: rowSelection, pagination: pagination }))));
}
exports.default = Table;
//# sourceMappingURL=index.js.map